var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.816662 12.7037C-0.00976908 11.8773 -0.00976968 10.5374 0.816662 9.71094C1.64309 8.88451 2.983 8.88451 3.80943 9.71094L6.89393 12.7954V2.11598C6.89393 0.947227 7.84139 -0.000232697 9.01014 -0.000232697C10.1789 -0.000232697 11.1263 0.947227 11.1263 2.11598V12.7751L14.1905 9.71094C15.0169 8.88451 16.3568 8.88451 17.1833 9.71094C18.0097 10.5374 18.0097 11.8773 17.1833 12.7037L10.5067 19.3803C10.091 19.796 9.5434 20.0027 8.99997 20.0001C8.45654 20.0027 7.90895 19.796 7.49324 19.3803L0.816662 12.7037Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.c67073db5caa4fac8cc83340982a5cb3.svg";
export { ForwardRef as ReactComponent };